import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserContext } from 'providers/UserProvider';
import { authApi } from 'api';

const HomeRedirector = () => {
  const { selectedTenant, selectedWarehouse } = useUserContext();
  const navigate = useNavigate();

  useEffect(() => {
    const tenant = selectedTenant?.domains?.[0]?.domain;
    const warehouse = selectedWarehouse?.domain;

    if (tenant && warehouse) {
      navigate(`/${tenant}/${warehouse}/`);
    } else {
      const logoutAndRedirect = async () => {
        try {
          await authApi.logout();
          navigate('/auth/login');
        } catch (error) {
          console.error('Failed to logout:', error);
          navigate('/auth/login');
        }
      };
      logoutAndRedirect();
    }
  }, [navigate, selectedTenant, selectedWarehouse]);

  return null; // This component doesn't render anything
};

export default HomeRedirector;
